import React from "react";
import { MapPinIcon, StarIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { testimonials } from "../../data/content";
function Stars({
  size = "h-4 w-4"
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-240" data-mp="3r7io7eb1h01y">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-[#F5A623] text-[#F5A623]`} aria-hidden="true" data-id="element-241" data-mp="1hi7k5xkwn6" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <Section tone="white" wide data-id="element-242" data-mp="44vzee5lvj27">
      <SectionHeading kicker="What other nail educators are saying" data-id="element-243" data-mp="91e4jf4uljf2">
        Educators love having a <em className="text-berry" data-id="element-244" data-mp="e0qp1t88yeeh">system</em> instead of a blank page
      </SectionHeading>

      <div className="mt-6 flex items-center justify-center gap-3" data-id="element-245" data-mp="2atir0b3kvoie">
        <span className="font-serif text-[36px] font-bold text-ink" data-id="element-246" data-mp="2avde9w2bnspn">4.9/5</span>
        <Stars size="h-6 w-6" data-id="element-247" data-mp="2fsvorqvzmfzr" />
      </div>

      <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-248" data-mp="1skj3c9xwcvjw">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl border border-petal bg-cream p-5 md:p-6" data-id="element-249" data-mp="1ntsxkvlk6qoo">
            <div className="flex items-center gap-4" data-id="element-250" data-mp="1iugb4bylnlmm">
              <img src={t.photo} alt={`Photo of ${t.name}`} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-white" loading="lazy" data-id="element-251" data-mp="1iuzjb0yg6vng" />
              <div data-id="element-252" data-mp="26kaoqvqqte7x">
                <figcaption className="text-[17px] font-bold text-ink" data-id="element-253" data-mp="26jskbbtxftox">{t.name}</figcaption>
                <p className="mt-0.5 flex items-center gap-1 text-[13px] text-muted" data-id="element-254" data-mp="22igqsv7xmobg">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-255" data-mp="1xjm7zt9yszrc" />
                  {t.country} · Nail Educator
                </p>
                <div className="mt-1" data-id="element-256" data-mp="r4l9bftk23h2">
                  <Stars data-id="element-257" data-mp="r1h02418ghjj" />
                </div>
              </div>
            </div>
            <blockquote className="mt-4 text-[16px] leading-relaxed text-ink" data-id="element-258" data-mp="m35p1pz7c0zq">“{t.quote}”</blockquote>
          </figure>)}
      </div>

      <CTAButton label="I want to teach like a professional educator" data-id="element-259" data-mp="skgxoqosdu34" />
    </Section>;
}